"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToasts = exports.ToastProvider = exports.ToastConsumer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Toast = _interopRequireDefault(require("./Toast"));

var _SnackBarToast = _interopRequireDefault(require("./SnackBarToast"));

var _IconToast = _interopRequireDefault(require("./IconToast"));

require("./ToastContainer.scss");

var _excluded = ["id"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var queueContext = /*#__PURE__*/_react["default"].createContext({
  queue: [],
  addToast: function addToast() {},
  removeToast: function removeToast() {}
});

var useQueueContext = function useQueueContext() {
  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      queue = _useState2[0],
      setQueue = _useState2[1];

  var idCounter = (0, _react.useRef)(0);

  var addToast = function addToast(message, options) {
    return setQueue(function (q) {
      return [].concat(_toConsumableArray(q), [_objectSpread({
        id: idCounter.current++,
        message: message
      }, options)]);
    });
  };

  var removeToast = function removeToast(id) {
    return setQueue(function (q) {
      return q.filter(function (toast) {
        return toast.id !== id;
      });
    });
  };

  return {
    queue: queue,
    addToast: addToast,
    removeToast: removeToast
  };
};

var useToasts = function useToasts() {
  var ctx = (0, _react.useContext)(queueContext);
  return _objectSpread({}, ctx);
};

exports.useToasts = useToasts;

var ToastContainer = function ToastContainer() {
  var _useToasts = useToasts(),
      queue = _useToasts.queue,
      removeToast = _useToasts.removeToast;

  var positions = ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'];

  var toastContainer = function toastContainer(position) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: position,
      className: 'gcl-toast-container ' + position
    }, queue.filter(function (t) {
      return t.position === position;
    }).map(function (_ref) {
      var id = _ref.id,
          toast = _objectWithoutProperties(_ref, _excluded);

      return /*#__PURE__*/_react["default"].createElement(ToastChooser, {
        key: id,
        group: toast.group,
        toast: toast,
        onClose: function onClose() {
          return removeToast(id);
        }
      });
    }));
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, positions.map(function (position) {
    return toastContainer(position);
  }));
};

var ToastChooser = function ToastChooser(_ref2) {
  var group = _ref2.group,
      toast = _ref2.toast,
      onClose = _ref2.onClose;

  switch (group) {
    case 'snackbar':
      return /*#__PURE__*/_react["default"].createElement(_SnackBarToast["default"], _extends({
        onClose: onClose
      }, toast));

    case 'inbox':
      return /*#__PURE__*/_react["default"].createElement(_Toast["default"], _extends({
        onClose: onClose
      }, toast));

    case 'icon':
      return /*#__PURE__*/_react["default"].createElement(_IconToast["default"], _extends({
        onClose: onClose
      }, toast));

    default:
      return null;
  }
};

var ToastProvider = function ToastProvider(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_react["default"].createElement(queueContext.Provider, {
    value: useQueueContext()
  }, /*#__PURE__*/_react["default"].createElement(ToastContainer, null), children);
};

exports.ToastProvider = ToastProvider;

var ToastConsumer = function ToastConsumer(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement(queueContext.Consumer, null, function (context) {
    return children(context);
  });
};

exports.ToastConsumer = ToastConsumer;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Toasts/Toasts.js
// module id = 1933
// module chunks = 0